import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/wx.png'


const _withScopeId = n => (_pushScopeId("data-v-0716db12"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = {
  class: "card",
  style: {"text-align":"left"}
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "nameOrphone"
}
const _hoisted_6 = { class: "address" }
const _hoisted_7 = { class: "card" }
const _hoisted_8 = { class: "productName" }
const _hoisted_9 = { class: "tag" }
const _hoisted_10 = { class: "select" }
const _hoisted_11 = { class: "total" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 商品总价: ")
const _hoisted_13 = { class: "totalPrice" }
const _hoisted_14 = { class: "aggregate" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 总计: ")
const _hoisted_16 = { class: "aggregatePrice" }
const _hoisted_17 = {
  key: 0,
  class: "flex",
  style: {"margin":"0.16rem 0 0"}
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "卡板编码：", -1))
const _hoisted_19 = { class: "value" }
const _hoisted_20 = { class: "card" }
const _hoisted_21 = { class: "flex" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "支付方式", -1))
const _hoisted_23 = { class: "value" }
const _hoisted_24 = {
  key: 0,
  style: {"height":"0.32rem"},
  src: _imports_0,
  alt: ""
}
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "flex" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "支付时间", -1))
const _hoisted_28 = { class: "value" }
const _hoisted_29 = { class: "flex" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "订单编号", -1))
const _hoisted_31 = { class: "value" }
const _hoisted_32 = { class: "flex" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "配送方式", -1))
const _hoisted_34 = { class: "value" }
const _hoisted_35 = {
  key: 0,
  class: "flex",
  style: {"flex-direction":"column","align-items":"start"}
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "订单备注", -1))
const _hoisted_37 = { class: "remarks" }
const _hoisted_38 = {
  key: 1,
  class: "flex",
  style: {"flex-direction":"column","align-items":"start"}
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "下单失败原因", -1))
const _hoisted_40 = { class: "remarks" }
const _hoisted_41 = { class: "footer" }
const _hoisted_42 = { class: "action" }

import { ref, reactive, onMounted } from "vue";
import { useRouter } from "vue-router";
import router from "@/router";
import { useRoute } from "vue-router";
import {
  Button,
  Field,
  Cell,
  CellGroup,
  Toast,
  NavBar,
  Tabs,
  Tab,
  List,
  Icon,
} from "vant";
import { request } from "@/provide/fetch";
import { getChannelCodeFromCache } from "@/utils/channelCode";

export default /*#__PURE__*/_defineComponent({
  name: 'orderDetails',
  setup(__props) {

const route = useRoute();
const orderId = route.params.id;
const tabList = ref([
  {
    name: "待付款",
    value: 1,
    title: "订单待付款",
  },
  {
    name: "待发货",
    value: 2,
    title: "订单待发货",
  },
  {
    name: "待收货",
    value: 3,
    title: "订单待收货",
  },
  {
    name: "待领取",
    value: 4,
    title: "订单待领取",
  },
  {
    name: "已完成",
    value: 5,
    title: "订单已完成",
  },
  {
    name: "已取消",
    value: 6,
    title: "订单已取消",
  },
  {
    name: "已退款",
    value: 7,
    title: "订单已退款",
  },
]);
const object = ref({
  userName: "",
  phone: "",
  address: "",
  title: "",
  productName: "新马泰印尼5G高速上网卡",
  flowGear: "1GB/天",
  fate: "1",
  tags: ["5G高速", "插卡激活", "可充值"],
  orderNo: "",
  payTime: "",
  payType: "",
  orderComment: "",
  payPrice: 0,
  supplierFailReason: "",
});
const initData = () => {
  request({
    url: `/order/detail/${route.params.id}`,
    method: "POST",
  }).then((res) => {
    object.value = res.data;
    object.value.title =
      tabList.value.filter((item) => res.data.orderStatus == item.value)[0]
        .title || "订单详情";
    request({
      url: `/order/address/detail/${res.data.addressId}`,
      method: "POST",
    }).then((res: any) => {
      request({
        url: `/order/address/detail/${res.data.addressId}`,
        method: "POST",
      }).then((res: any) => {
        object.value.userName = res.data.userName;
        object.value.phone = res.data.phone;
        object.value.address =
          res.data.province +
          res.data.city +
          res.data.country +
          res.data.detailAddress;
      });
    });
  });
};
if (orderId) {
  initData();
}
const userIP = ref();
onMounted(async () => {
  const res = await fetch("https://ip.liulv.net/ip");
  const data = await res.json();
  userIP.value = data.ip;
});
const handlePay = (item: any) => {
  //
  const data = {
    orderId: item.parentOrderId,
    payType: item.payType,
    // payType: 2,
    price: item.payPrice,
    clientIp: userIP.value,
    channel: getChannelCodeFromCache(),
    openId: localStorage.getItem("bjopenid"),
    wayCode: item.payType == 3 ? "OFFLINE_CASH" : "WX_JSAPI",
  };
  request({
    url: "/bj-pay/pay",
    method: "POST",
    data: data,
  }).then((res) => {
    if (item.payType == 3) {
      router.push({
        path: "/OrderPage",
      });
    } else {
      const data = JSON.parse(res.data.payData);
      const mchOrderNo = res.data.mchOrderNo;
      wx.chooseWXPay({
        timestamp: data.timeStamp,
        nonceStr: data.nonceStr,
        package: data.package,
        signType: data.signType,
        paySign: data.paySign,
        appId: data.appId,
        success: function (res: any) {
          router.push({
            path: "/SuccessPay",
            query: { payNo: mchOrderNo },
          });
        },
        complete: (res: any) => {
          console.log("complete");
          console.log(res.errMsg);
          if (res.errMsg === "chooseWXPay:cancel") {
            router.push({
              path: "/OrderPage",
            });
          }
        },
      });
    }
  });
};
const handleCancelOrder = (item: any) => {
  request({
    url: `/order/cancel/${item.orderId}`,
    method: "POST",
  })
    .then((res) => {
      if (res.code === 200) {
        Toast("取消成功");
        initData();
      } else {
        Toast(res.message);
      }
    })
    .catch(() => {
      Toast("网络错误，请稍后重试");
    });
};
// 申请退款
const handleRefund = (item: any) => {
  request({
    url: `/bj-pay/refund`,
    method: "POST",
    data: {
      orderNo: item.orderNo,
      channel: getChannelCodeFromCache(),
    },
  })
    .then((res) => {
      if (res.code === 200) {
        Toast("操作成功");
        initData();
      } else {
        Toast(res.message);
      }
    })
    .catch(() => {
      Toast("网络错误，请稍后重试");
    });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(NavBar), {
      title: object.value.title,
      "left-arrow": "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).go(-1)))
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (object.value.orderOperatorType == 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, " 卡板编码：" + _toDisplayString(object.value.sn), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("span", null, _toDisplayString(object.value.userName), 1),
              _createElementVNode("span", null, _toDisplayString(object.value.phone), 1)
            ])),
        _createElementVNode("div", _hoisted_6, _toDisplayString(object.value.address), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, _toDisplayString(object.value.productName), 1),
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(object.value.productSellPoints, (tagItem) => {
            return (_openBlock(), _createElementBlock("span", {
              key: tagItem,
              class: "tagItem"
            }, _toDisplayString(tagItem), 1))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_10, _toDisplayString(object.value.flowLevel) + " × " + _toDisplayString(object.value.selectDays), 1),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("span", _hoisted_13, "¥" + _toDisplayString(object.value.payPrice / 100), 1)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("span", _hoisted_16, "¥" + _toDisplayString(object.value.payPrice / 100), 1)
        ]),
        (object.value.iccid)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("span", _hoisted_19, _toDisplayString(object.value.iccid), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _createElementVNode("span", _hoisted_23, [
            (object.value.payType == '1')
              ? (_openBlock(), _createElementBlock("img", _hoisted_24))
              : _createCommentVNode("", true),
            (object.value.payType == '3')
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, "现金支付"))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _createElementVNode("span", _hoisted_28, _toDisplayString(object.value.payTime), 1)
        ]),
        _createElementVNode("div", _hoisted_29, [
          _hoisted_30,
          _createElementVNode("span", _hoisted_31, _toDisplayString(object.value.orderNo), 1)
        ]),
        _createElementVNode("div", _hoisted_32, [
          _hoisted_33,
          _createElementVNode("span", _hoisted_34, _toDisplayString(object.value.deliveryType == "1" ? "普通快递包邮" : "线下自提"), 1)
        ]),
        (object.value.orderComment)
          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
              _hoisted_36,
              _createElementVNode("span", _hoisted_37, _toDisplayString(object.value.orderComment), 1)
            ]))
          : _createCommentVNode("", true),
        (object.value.supplierFailReason)
          ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
              _hoisted_39,
              _createElementVNode("span", _hoisted_40, _toDisplayString(object.value.supplierFailReason), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_41, [
        _createElementVNode("div", _hoisted_42, [
          (object.value.orderStatus == 1)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (handleCancelOrder(object.value)), ["stop"])),
                class: "btn cancel"
              }, " 取消订单 "))
            : _createCommentVNode("", true),
          (object.value.orderStatus == 1)
            ? (_openBlock(), _createElementBlock("span", {
                key: 1,
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (handlePay(object.value)), ["stop"])),
                class: "btn submit"
              }, "去支付"))
            : _createCommentVNode("", true),
          ([2, 3, 4].includes(object.value.orderStatus))
            ? (_openBlock(), _createElementBlock("span", {
                key: 2,
                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (handleRefund(object.value)), ["stop"])),
                class: "btn submit"
              }, " 申请退款 "))
            : _createCommentVNode("", true),
          (
              [3, 5].includes(object.value.orderStatus) &&
              object.value.orderOperatorType !== 2
            )
            ? (_openBlock(), _createElementBlock("span", {
                key: 3,
                onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (
              _unref(router).push(`/logistics/${object.value.orderNo}/${object.value.logisticsNo}`)
            ), ["stop"])),
                class: "btn submit"
              }, " 查看物流 "))
            : _createCommentVNode("", true),
          ([5, 6, 7].includes(object.value.orderStatus))
            ? (_openBlock(), _createElementBlock("span", {
                key: 4,
                onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_unref(router).push('/hotGoodsDetails/' + object.value.productId)), ["stop"])),
                class: "btn submit"
              }, "再次购买"))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})